import anime from 'animejs';
import MicroModal from 'micromodal';

MicroModal.init({
    onShow: (modal) => modalInAnimation(modal),
    closeTrigger: 'custom',
    debug: true
});

const overlay = document.querySelector('.modal__overlay');
const modalCloseBtn = document.querySelector('.modal__close-button');
const modalCloseBtnMobile = document.querySelector('.modal__close-button-mobile') ? document.querySelector('.modal__close-button-mobile') : '';
const modalNavButtons = document.querySelectorAll('.pdp__modal-nav-button');
const tabpanels = document.querySelectorAll('.pdp__modal-tabpanel');

const changeProductSize = (e) => {
    e.preventDefault();
    const clickedId = e.target.hash.substr(1); // removes hash mark

    tabpanels.forEach((panel) => {
        panel.setAttribute('hidden', '');
        if (panel.id === clickedId) {
            panel.removeAttribute('hidden');
        }
    });

    modalNavButtons.forEach((btn) => {
        btn.setAttribute('aria-selected', 'false');
    });
    e.target.setAttribute('aria-selected', 'true');
};

const modalInAnimation = modal => {
  const overlay = modal.querySelector('.modal__overlay');
  const content = modal.querySelector('.modal__content');
  anime({
    targets: overlay,
    opacity: [0, 1],
    easing: 'linear',
    duration: 200
  })
  anime({
    targets: [content, modalCloseBtnMobile],
    translateY: [-100, 0]
  })
}

const modalOutAnimation = () => {
  const modal = document.querySelector('.modal.is-open');
  const overlay = modal.querySelector('.modal__overlay');
  const content = modal.querySelector('.modal__content');
  anime({
    targets: overlay,
    opacity: [1, 0],
    easing: 'linear',
    duration: 200,
    complete: () => {
      MicroModal.close(modal.id);
    }
  })
  anime({
    targets: [content, modalCloseBtnMobile],
    translateY: -300,
    easing: 'linear',
    duration: 200
  })
}


if (modalNavButtons.length > 0) {
    modalNavButtons.forEach((el) => {
        el.addEventListener('click', (e) => changeProductSize(e));
    });
}

if (overlay) {
  overlay.addEventListener('click', e => {
    if (e.target === e.currentTarget) {
      modalOutAnimation();
    }
  })
}

if (modalCloseBtn) {
  modalCloseBtn.addEventListener('click', modalOutAnimation);
}

if (modalCloseBtnMobile) {
  modalCloseBtnMobile.addEventListener('click', modalOutAnimation);
}
